import { atom } from "jotai";

export const showDocketsSidebarFlagAtom = atom(false);
